<template>
  <section class="banner-container">
    <div class="banner">
      <img :src="bannerOne" alt="" />
      <div class="content">
        <span>limited offer</span>
        <h3>upto 50% off</h3>
        <router-link to="" class="btn">shop now</router-link>
      </div>
    </div>
    <div class="banner">
      <img :src="bannerTwo" alt="" />
      <div class="content">
        <span>limited offer</span>
        <h3>upto 50% off</h3>
        <router-link to="" class="btn">shop now</router-link>
      </div>
    </div>
    <div class="banner">
      <img :src="bannerThree" alt="" />
      <div class="content">
        <span>limited offer</span>
        <h3>upto 50% off</h3>
        <router-link to="" class="btn">shop now</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      bannerOne: require("@/images/banner-1.jpg"),
      bannerTwo: require("@/images/banner-2.jpg"),
      bannerThree: require("@/images/banner-3.jpg"),
    };
  },
};
</script>